import Vue from "vue";
import VueRouter from "vue-router";
// import Home from "@/views/Home.vue";
import store from "@/store";
import { Message } from "element-ui";
import { getDefaultDate } from "@/api/baseInfo";
import { getUrlParams } from "@/utils";
import { parseTime } from "@/utils";
import FingerprintJS from '@fingerprintjs/fingerprintjs'
Vue.use(VueRouter);

const originalpush = VueRouter.prototype.push;

VueRouter.prototype.push = function push(location) {
  return originalpush.call(this, location).catch((err) => err);
};

const routes = [
  {
    path: "/",
    redirect: "/social",
  },

  {
    path: "/concept",
    name: "concept",
    component: () => import("@/views/Concept.vue"),
  },
  {
    path: "/social",
    name: "social",
    component: () => import("@/views/Social")
  },
  {
    path: "/brand",
    name: "brand",
    component: () => import("@/views/Brand.vue"),
  },
  {
    path: "/category",
    name: "category",
    component: () => import("@/views/Category.vue"),
  },
  {
    path: "/ebay",
    name: "ebay",
    component: () => import("@/views/Ebay.vue"),
  },
  {
    path: "/amazon",
    name: "amazon",
    component: () => import("@/views/Amazon.vue"),
  },
  {
    path: "/amazonBrand",
    name: "amazonBrand",
    component: () => import("@/views/AmazonBrand.vue")
  },
  {
    path: "/amazonCategory",
    name: "amazonCategory",
    component: () => import("@/views/AmazonCategory.vue")
  },
  {
    path: "/ebayDetail",
    name: "ebayDetail",
    component: () => import("@/views/EbayDetail"),
  },
  {
    path: "/publicDetail",
    name: "publicDetail",
    component: () => import("@/views/PublicDetail"),
  },
  {
    path: "/myAttention",
    name: "myAttention",
    component: () => import("@/views/MyAttention.vue"),
  },
  {
    path: "/setUp",
    name: "setUp",
    component: () => import("@/views/SetUp.vue"),
  },
  {
    path: "/search",
    name: "search",
    component: () => import("@/views/Search.vue"),
  },
  {
    path: "/detail",
    name: "detail",
    component: () => import("@/views/Detail"),
  },
  //   {
  //     path: "/selector",
  //     name: "selector",
  //     component: () => import("@/views/Selectors.vue"),
  //   },
];

const router = new VueRouter({
  routes,
});

const getDefaultDateFun = async (to, next) => {
  let params = {};
  //   params.plat = store.state.user.plants
  //     ? store.state.user.plants.join(",")
  //     : "";
  await getDefaultDate(params).then((res) => {
    if (res.status == "ok") {
      store.dispatch("user/changeStartMonth", res.result.start);
      store.dispatch("user/changeEndMonth", res.result.end);
      localStorage.setItem("defaultStartMonth", res.result.start);
      localStorage.setItem("defaultEndMonth", res.result.end);
      router.push({
        name: to.name,
        query: {
          start: parseTime(store.state.user.startMonth, "{y}-{m}"),
          end: parseTime(store.state.user.endMonth, "{y}-{m}"),
        },
      });
      next();
    }
  });
  //   } else {
  //     return;
  //   }
};

router.beforeEach(async (to, from, next) => {
  const browserFinger = localStorage.getItem('browserFinger')
  if(!browserFinger){
    const fpPromise = FingerprintJS.load()
    const fp = await fpPromise
    const result = await fp.get()
    localStorage.setItem('browserFinger', result.visitorId)
  }
  const localeLanguage = localStorage.getItem("language");
  if (store.state.user.loginInfo.partner_title) {
    document.title = store.state.user.loginInfo.partner_title;
  } else {
    if (localeLanguage == "en") {
      document.title = "Moojing Chance";
    } else {
      document.title = "魔镜增长雷达";
    }
  }
  sessionStorage.removeItem("checkedState");
  if (
    to.path.includes("/concept") ||
    to.path.includes("/brand") ||
    to.path.includes("/category") ||
    to.path == "/ebay" ||
    to.path.includes("/amazon") ||
    to.path.includes("/amazonBrand") ||
    to.path.includes("/amazonCategory") ||
    to.path.includes("/myAttention") ||
    to.path.includes("/setUp")
  ) {
    store.dispatch("user/changeShowMainHead", false);
    store.dispatch("user/changeShowTopHead", true);
    store.dispatch("user/changeEbayShowMainHead", false);
    store.dispatch("user/changeShowEbayTopHead", false);
    store.dispatch("user/changePublicShowMainHead", false);
  } else {
    if (to.path.includes("/detail")) {
      store.dispatch("user/changeActivedTab", "TrendList");
      store.dispatch("user/changeShowMainHead", true);
      store.dispatch("user/changeShowTopHead", true);
      store.dispatch("user/changeEbayShowMainHead", false);
      store.dispatch("user/changeShowEbayTopHead", false);
      store.dispatch("user/changePublicShowMainHead", false);
    } else if (to.path.includes("/ebayDetail")) {
      store.dispatch("user/changeEbayActivedTab", "EbayTrendList");
      store.dispatch("user/changeShowMainHead", false);
      store.dispatch("user/changeShowTopHead", false);
      store.dispatch("user/changeEbayShowMainHead", true);
      store.dispatch("user/changeShowEbayTopHead", true);
      store.dispatch("user/changePublicShowMainHead", false);
    } else if (to.path.includes("/publicDetail")) {
        store.dispatch("user/changePublicActivedTab", "PublicTrendList");
        store.dispatch("user/changeShowMainHead", false);
        store.dispatch("user/changeShowTopHead", true);
        store.dispatch("user/changeEbayShowMainHead", false);
        store.dispatch("user/changePublicShowMainHead", true);
        store.dispatch("user/changeShowEbayTopHead", false);
      } else {
      store.dispatch("user/changeShowMainHead", false);
      store.dispatch("user/changeShowTopHead", true);
      store.dispatch("user/changeEbayShowMainHead", false);
      store.dispatch("user/changeShowEbayTopHead", false);
      store.dispatch("user/changePublicShowMainHead", false);
    }
  }
  if (to.matched.length == 0 && !to.path.includes("/mj_logout")) {
    next({ path: "/concept" });
  }
  //   if (
  //     !getUrlParams("start") &&
  //     !getUrlParams("end") &&
  //     !store.state.user.startMonth &&
  //     !store.state.user.endMonth
  //   ) {
  //     await getDefaultDateFun(to, next);
  //   } else {
  //     next();
  //   }
  next();
});

export default router;
